import { createFileRoute, useLocation } from "@tanstack/react-router";

import { useT } from "../../app/i18n";
import { ResetPasswordForm } from "../../features/auth/password-reset-forms";

export const Route = createFileRoute("/_auth/reset-password")({ component: ResetPasswordPage });

function ResetPasswordPage() {
  const { t } = useT();
  // The e-mailed link is `/reset-password#token=…`: a fragment never reaches a server or its logs.
  const hash = useLocation({ select: (location) => location.hash });
  const token = new URLSearchParams(hash.replace(/^#/, "")).get("token") ?? undefined;
  return (
    <>
      <h1 className="mb-6 text-xl font-semibold">{t("auth:reset.title")}</h1>
      <ResetPasswordForm token={token} />
    </>
  );
}
